<!-- @format -->

<career-years>
  <h3 class="heading-03">経験年数</h3>
  <table class="detail_table">
    <tr class="detail_table-row_02" each="{ row in getTypeMaster() }">
      <template each="{ type in row }">
        <th class="detail_table-heading">{ type.jname }</th>
        <td class="detail_table-data">
          <div class="sort-menu margin-spacing-2_right">
            <select
              name="career_type_id_{ type.id }"
              class="sort-list"
              onchange="{ e => onSelect(e, type.id) }"
            >
              <option value="0">--</option>
              <option each="{ year in props.master.year }" value="{ year.id }">
                { year.year_number_jname }
              </option>
            </select>
          </div>
          <!--/.sort-menu-->
        </td>
      </template>
    </tr>
  </table>

  <!--/.detail_table-->

  <script>
    export default {
      onMounted(props) {
        this.onUpdated(props, props);
      },
      getTypeMaster() {
        const row = Math.ceil(this.props.master.type.length / 2);
        let list = [];
        for (let i = 0; i < row; ++i) {
          list.push(this.props.master.type.slice(i * 2, i * 2 + 2));
        }
        return list;
      },
      onUpdated(newProps, curProps) {
        for (const type of newProps.master.type) {
          this.$(`[name="career_type_id_${type.id}"]`).value = newProps.data[
            type.id
          ]
            ? newProps.data[type.id]
            : 0;
        }
      },
      onSelect(e, id) {
        let data = this.props.data;
        data[id] = e.target.value;
        this.props.onUpdate(data);
      },
    };
  </script>
</career-years>
